import { render, staticRenderFns } from "./survey-list.vue?vue&type=template&id=6cc9fb33&scoped=true&"
import script from "./survey-list.vue?vue&type=script&lang=ts&"
export * from "./survey-list.vue?vue&type=script&lang=ts&"
import style0 from "./survey-list.vue?vue&type=style&index=0&id=6cc9fb33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9fb33",
  null
  
)

export default component.exports